import { all, fork } from 'redux-saga/effects';

import listenChangeStatusFilter from './listenChangeStatusFilter';
import listenLoad from './listenLoad';
import listenLoadPage from './listenLoadPage';

export default function* myCarsSaga() {
  yield all([fork(listenLoad), fork(listenLoadPage), fork(listenChangeStatusFilter)]);
}
